import { V1ClinicPaginationResponse } from "../../types/v1_schemas";
import ResultCard from "./ResultCard";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import RAECard from "./RAECard";
import HCPFCard from "./HCPFCard";
import { Fragment } from "react";


type ResultsListProps = {
  clinicPaginationResponse: V1ClinicPaginationResponse,
  zipCode: string,
  selectedResultId?: string;
  isMobile?: boolean;
  showRae: boolean;
};

const DESKTOP_CLASSES = "border-bottom border-base-lighter result-card-inactive";
const DESKTOP_CLASSES_ACTIVE = "border-05 radius-sm border-primary-light result-card-active";
const MOBILE_CLASSES = "border border-base-lighter radius-lg padding-2 margin-bottom-1";

const StyledResultsPagination = styled.div`
  margin-top: 1rem;
  margin-bottom: 1rem;
  margin-left: 2.5rem;
  .spacer {
    margin-left: -3.5rem;
    color: #51534b;
  }
`;

const ResultsList = ({
  clinicPaginationResponse,
  zipCode,
  selectedResultId,
  isMobile = false,
  showRae
}: ResultsListProps) => {
  const { t } = useTranslation();
 
  let resultsSlice = clinicPaginationResponse.data;

  const totalItems = clinicPaginationResponse.totalCount;
  const firstResult = clinicPaginationResponse.pageNumber === 1 ? 1 : ((clinicPaginationResponse.pageNumber - 1) * clinicPaginationResponse.pageSize) + 1;
  const lastResult = 
    (clinicPaginationResponse.pageNumber === 1 
  ? (clinicPaginationResponse.data.length < clinicPaginationResponse.pageSize ? clinicPaginationResponse.data.length : clinicPaginationResponse.pageSize)
  : (clinicPaginationResponse.pageNumber * clinicPaginationResponse.pageSize > totalItems ? totalItems : clinicPaginationResponse.pageNumber * clinicPaginationResponse.pageSize)) ;


  return (
    <>
      {showRae ? 
      <RAECard zipCode={zipCode} isMobile={isMobile}></RAECard>
      : <></>}
      <StyledResultsPagination 
      as="div">
      <div>
          {t("paginationHeading", {
            firstResult: firstResult,
            lastResult: lastResult,
            results: totalItems,
          })}
        </div>
        <div className="spacer"></div>

      </StyledResultsPagination>

      {clinicPaginationResponse.data.length > 0 &&
        resultsSlice.map((result, index) => (
          <Fragment key={result.accountId ?? index}>
            <div
              className={
                isMobile
                  ? MOBILE_CLASSES
                  : selectedResultId === result.accountId
                  ? DESKTOP_CLASSES_ACTIVE
                  : DESKTOP_CLASSES
              }
              key={result.accountId}
            >
              <ResultCard data={result} isMobile={isMobile} />
            </div>
            {(!(resultsSlice.length <= 4 && index !== resultsSlice.length - 1) && index === 3) ?
              !isMobile ?
                <div className="hcpf-card-div">
                  <HCPFCard isMobile={isMobile} />
                </div>
              :
                <HCPFCard isMobile={isMobile} />
            : <></>}
          </Fragment>
        ))}
    </>
  );
};

export default ResultsList;
